import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { env } from '../env';

export const firebaseApp: FirebaseApp = initializeApp(env.firebase);

export const auth: Auth = getAuth(firebaseApp);
